var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLivecasinoicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_7_10",
    "data-name": "Component 7 \\u2013 10",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 55.842,
    viewBox: "0 0 56 55.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M1621.6,666.11l7.235.2a20.506,20.506,0,0,1,2.428-8.1l-6.149-3.8a27.706,27.706,0,0,0-3.515,11.7Z",
    transform: "translate(-1621.536 -640.188)",
    fill: "#ce9421"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M1664.365,569.745l6.151,3.8a21.062,21.062,0,0,1,6.184-5.778l-3.4-6.371a28.1,28.1,0,0,0-8.935,8.346Z",
    transform: "translate(-1659.508 -557.565)",
    fill: "#ce9421"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M1774.034,534.3v-7.22a27.875,27.875,0,0,0-10.878,2.7l3.4,6.37a20.694,20.694,0,0,1,7.479-1.851Z",
    transform: "translate(-1747.235 -527.079)",
    fill: "#ce9421"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M1881.834,534.3a20.651,20.651,0,0,1,8.183,2.191l3.637-6.238a27.881,27.881,0,0,0-11.82-3.174v7.22Z",
    transform: "translate(-1852.621 -527.079)",
    fill: "#ce9421"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M1976.731,575.2a20.942,20.942,0,0,1,2.745,3.374l6.289-3.569a28.118,28.118,0,0,0-8.615-8.675l-3.638,6.24a21.023,21.023,0,0,1,3.219,2.631Z",
    transform: "translate(-1934.031 -561.948)",
    fill: "#ce9421"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M2043.734,662.705l-6.288,3.568a20.543,20.543,0,0,1,2.12,8.184l7.238.067a27.723,27.723,0,0,0-3.07-11.819Z",
    transform: "translate(-1990.804 -647.553)",
    fill: "#ce9421"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M1663.244,878.8a1.913,1.913,0,1,1-1.918,1.913,1.915,1.915,0,0,1,1.918-1.913Zm1.942,8.463,3.755-6.171a21.069,21.069,0,0,1-5.85-6.114l-6.355,3.45a28.1,28.1,0,0,0,8.451,8.835Z",
    transform: "translate(-1652.733 -836.113)",
    fill: "#ce9421"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M1982.885,884.522l-6.221-3.687a21.073,21.073,0,0,1-6.074,5.892l3.519,6.306a28.092,28.092,0,0,0,8.776-8.512Z",
    transform: "translate(-1931.436 -841.314)",
    fill: "#ce9421"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M1630.2,789.075a20.563,20.563,0,0,1-1.963-8.221l-7.237-.2a27.752,27.752,0,0,0,2.846,11.876l6.354-3.45Z",
    transform: "translate(-1621 -752.321)",
    fill: "#ce9421"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M1889.792,950.391l-3.519-6.305a20.677,20.677,0,0,1-8.209,2.035l-.052,7.219a27.929,27.929,0,0,0,11.78-2.949Z",
    transform: "translate(-1849.227 -897.498)",
    fill: "#ce9421"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M2038.147,789.45a20.53,20.53,0,0,1-2.274,8.141l6.219,3.687a27.717,27.717,0,0,0,3.293-11.76l-7.239-.067Z",
    transform: "translate(-1989.407 -760.138)",
    fill: "#ce9421"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M1716.268,619.359a2.257,2.257,0,0,1,2.2,2.792l6.218,6.245a3.483,3.483,0,0,1,2.211.014l6.056-6.082a2.228,2.228,0,0,1-.058-.506,2.263,2.263,0,1,1,2.264,2.258,2.219,2.219,0,0,1-.493-.055l-5.9,5.923a3.454,3.454,0,0,1,.281,2.831l5.524,5.548a2.227,2.227,0,0,1,.585-.077,2.257,2.257,0,1,1-2.226,1.846l-5.417-5.441a3.47,3.47,0,0,1-3.455.021l-5.472,5.5a2.263,2.263,0,1,1-2.206-1.752,2.217,2.217,0,0,1,.493.055l5.63-5.655a3.453,3.453,0,0,1,.288-2.907l-6.06-6.086a2.222,2.222,0,0,1-.465.048,2.258,2.258,0,1,1,0-4.516Zm9.179,30.233a18.319,18.319,0,1,0-18.365-18.319,18.363,18.363,0,0,0,18.365,18.319Z",
    transform: "translate(-1697.441 -603.359)",
    fill: "#ce9421"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M1762.46,950.5l.051-7.224a20.643,20.643,0,0,1-8.153-2.347l-3.754,6.169a27.881,27.881,0,0,0,11.856,3.4Z",
    transform: "translate(-1736.088 -894.69)",
    fill: "#ce9421"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivecasinoicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/live.casino.icon.c366df3ba0126d335ad967bd83448bae.svg";
export { ForwardRef as ReactComponent };